import { render, staticRenderFns } from "./EdicaoPesquisaAlerta.vue?vue&type=template&id=14fe0c0b&"
import script from "./EdicaoPesquisaAlerta.vue?vue&type=script&lang=js&"
export * from "./EdicaoPesquisaAlerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports